import Header from "./components/Header";
import Hero from "./components/Hero";
import QuemSomos from "./components/QuemSomos";
import NossosProdutos from "./components/NossosProdutos";
import MaiaSection from "./components/MaiaSection";
import Resultados from "./components/Resultados";
import Servicos from "./components/Servicos";
import HubSeguros from "./components/HubSeguros";
import Ecossistema from "./components/Ecossistema";
import Dores from "./components/Dores";
import Solucao from "./components/Solucao";
import Diferenciais from "./components/Diferenciais";
import MentoresRH from "./components/MentoresRH";
import Eventos from "./components/Eventos";
import Institucional from "./components/Institucional";
import CtaSection from "./components/CtaSection";
import FAQ from "./components/FAQ";
import Contato from "./components/Contato";
import Footer from "./components/Footer";
import JsonLd from "@/components/base/JsonLd";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://example.com";

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Ferrarezi Benefícios",
  "alternateName": "Ferrarezi",
  "url": siteUrl,
  "logo": `${siteUrl}/logo.png`,
  "description": "A Ferrarezi é uma aceleradora de pessoas e resultados. Especialista em benefícios corporativos, seguros empresariais e consultoria estratégica. Redução de custos, controle de sinistralidade, retenção de talentos e aumento de produtividade.",
  "foundingDate": "2011",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "São Paulo",
    "addressRegion": "SP",
    "addressCountry": "BR"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+55-11-93618-9998",
      "contactType": "customer service",
      "areaServed": "BR",
      "availableLanguage": ["Portuguese"]
    },
    {
      "@type": "ContactPoint",
      "telephone": "+55-11-93618-9998",
      "contactType": "sales",
      "areaServed": "BR",
      "availableLanguage": ["Portuguese"]
    }
  ],
  "sameAs": [
    "https://www.linkedin.com/company/ferrarezibeneficios",
    "https://www.instagram.com/ferrarezibeneficios",
    "https://www.facebook.com/ferrarezibeneficios"
  ],
  "areaServed": {
    "@type": "Country",
    "name": "Brazil"
  }
};

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <JsonLd data={organizationJsonLd} />
      <Header />
      <Hero />
      <QuemSomos />
      <NossosProdutos />
      <MaiaSection />
      <Resultados />
      <Servicos />
      <HubSeguros />
      <Ecossistema />
      <Dores />
      <Solucao />
      <Diferenciais />
      <MentoresRH />
      <Eventos />
      <Institucional />
      <CtaSection />
      <FAQ />
      <Contato />
      <Footer />
    </div>
  );
}